import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="container-saavi py-32 text-center">
      <div className="font-mono-overline text-saavi-red mb-3">404 · Not Found</div>
      <h1 className="text-5xl md:text-6xl">Page not found.</h1>
      <p className="mt-4 text-muted-foreground">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-8">
        <Link to="/"><Button size="lg" className="h-12 px-6">Back to Home</Button></Link>
      </div>
    </section>
  );
}
